<script setup lang="ts">
import { TheHumanBody } from '@ilteducation/games';
import { DialogCloseButton } from '@ilteducation/components';
import { ref } from 'vue';
import useKeywordsStore from '@/store/keywords';
import { useLocale } from '@/plugins/translation';
import GamesBackButton from '@/components/games/GamesBackButton.vue';

const { t, l } = useLocale();

const showKeywordInfo = ref(false);

const { getByKey, loadByKey } = useKeywordsStore();

const theHumanBody = ref<InstanceType<typeof TheHumanBody> | null>(null);

const keywordLabel = ref<string | undefined>();
const keyWordDescription = ref<string | undefined>();

const showKeywordDescription = async (kw: string) => {
  keywordLabel.value = undefined;
  keyWordDescription.value = undefined;
  showKeywordInfo.value = true;
  let keyword = getByKey(kw) || getByKey(kw.toLowerCase());
  if (!keyword) {
    keyword = await loadByKey(kw);
  }
  keywordLabel.value = kw;
  keyWordDescription.value = keyword?.description ?? '';
};

const closeKeywordDialog = () => {
  showKeywordInfo.value = false;
  keywordLabel.value = undefined;
  keyWordDescription.value = undefined;
  theHumanBody.value?.closeBodyPart();
};
</script>

<template>
  <v-container fluid class="skeletor-game pa-0">
    <v-card class="game-container" rounded="0">
      <GamesBackButton />
      <TheHumanBody
        ref="theHumanBody"
        @bodypart-clicked="showKeywordDescription"
        @info-panel-closed="closeKeywordDialog"
      />
      <v-card v-if="showKeywordInfo" class="keyword-card pa-5 rounded-lg" min-width="300px" max-width="500px">
        <v-progress-circular
          v-if="keywordLabel === undefined"
          indeterminate
          color="primary"
          :aria-label="t(l.label_loading)"
        ></v-progress-circular>
        <h1>{{ keywordLabel }}</h1>
        <p>{{ keyWordDescription }}</p>
        <DialogCloseButton variant="flat" size="small" @click="closeKeywordDialog" />
      </v-card>
    </v-card>
  </v-container>
</template>

<style scoped lang="scss">
.skeletor-game {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
}

.game-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.keyword-card {
  position: absolute;
  top: 100px;
  right: 100px;
  z-index: 10;
}
</style>
